import { useState } from "react";
import { Lock } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { api, formatError } from "@/lib/api";

export default function AdminLogin({ onLogin }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      onLogin(data);
    } catch (err) {
      setError(formatError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen flex-col bg-neutral-950" data-testid="admin-login-page">
      <div className="kente kente-band" />
      <div className="flex flex-1 items-center justify-center px-5">
        <form onSubmit={submit} className="rise w-full max-w-sm space-y-5 rounded-lg border border-neutral-800 bg-neutral-900 p-8" data-testid="admin-login-form">
          <Lock className="h-8 w-8 text-amber-400" />
          <h1 className="font-display text-3xl font-bold text-gold">
            Admin <span className="font-script normal-case tracking-normal text-red-500">login</span>
          </h1>
          <div className="space-y-2">
            <Label htmlFor="adm-email">Email</Label>
            <Input id="adm-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="field-input" data-testid="admin-login-email-input" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="adm-pass">Password</Label>
            <Input id="adm-pass" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="field-input" data-testid="admin-login-password-input" />
          </div>
          {error && <p className="text-sm text-red-400" data-testid="admin-login-error">{error}</p>}
          <button type="submit" disabled={loading} className="h-12 w-full rounded-full bg-amber-500 font-display text-lg font-semibold text-neutral-950 transition-colors hover:bg-amber-400 disabled:opacity-60" data-testid="admin-login-submit-button">
            {loading ? "Signing in…" : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
}
